/* eslint-disable array-callback-return */
/* eslint-disable sonarjs/no-ignored-return */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useMsal } from "@azure/msal-react";
import { addLocale } from "primereact/api";
import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import moment from "moment";
import Dialog from "../../components/Dialog";
import { ptBrDatepickerTranslations } from "../../i18n/locales/pt-br";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import StringUtils from "../../utils/types/StringUtils";
import { axiosGetRequest } from "../../api/ApiClient";
import { StyledInfoText } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import GenericUtils from "../../utils/GenericUtils";
import { InformationIcon, UserIcon } from "../../components/Icons";
import CheckRadioStyles from "../../styles/components/CheckRadioStyles";
import SelectOption from "../../model/SelectOption";
import AutocompleteAbono from "../../components/AutocompleteAbono";
import InputCalendarStyles from "../../styles/components/InputCalendarStyles";
import { stylesBoxsModalDetalhes } from "../../styles/pages/GestaoFaltas/GestaoFaltas";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary, DefaultButtonLink, BtnOutlinePrimary } = ButtonStyles;
const { StyledModalTitle } = DialogStyles;

interface IModalProps {
    open: boolean;
    solicitacaoI: any;
    dadosWorkflowI: any;
    docenteIdI: any;
    inEdit: boolean;
    onClose?: (callback?: any) => void;
    onDeferir: (callback?: any) => void;
    onIndeferir: (callback?: any) => void;
    readOnly?: boolean;
}

const ModalDetalhes: React.FC<IModalProps> = ({
    open,
    inEdit,
    onClose,
    onDeferir,
    onIndeferir,
    dadosWorkflowI,
    solicitacaoI,
    readOnly = false,
}) => {
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();
    const [abonos, setAbonos] = useState<SelectOption[]>([]);
    const [selected, setSelected] = useState<any[]>([]);
    const [datePicker, setDatePicker] = useState<any>("");
    const [periodoAbono, setPeriodoAbono] = useState("");
    const [docenteID, setDocenteID] = useState("");
    const [telefone, setTelefone] = useState("");
    const [email, setEmail] = useState("");
    const [rangeTime, setRangeTime] = useState("");
    const [qtdDias, setQtdDias] = useState("");
    const [dadosWorkflow, setDadosWorkflow] = useState<any>();
    const [solicitacao, setSolicitacao] = useState<any>();
    const [isEdit, setIsEdit] = useState(false);

    const getAbonos = async () => {
        const newAbonos: SelectOption[] = [];
        const response = await axiosGetRequest(
            `/docente/v1/tipo-abono?_limit=500000&ativos=true`,
            acessToken,
            instance
        );
        response?.data?.map((data: any) =>
            newAbonos.push({
                value: data.tipoAbonoID,
                label: data.motivo,
            })
        );
        setAbonos(newAbonos);
        setPeriodoAbono(solicitacaoI?.tipo);
        setDatePicker(moment(solicitacaoI?.data).toDate());
        setRangeTime(
            `${solicitacaoI?.periodoInicio} às ${solicitacaoI?.periodoFim}`
        );
        setTelefone(solicitacaoI?.telefone);
        setDocenteID(solicitacaoI?.docenteId);
        setQtdDias(solicitacaoI?.quantidadeDias);
        setEmail(solicitacaoI?.email);
        newAbonos.map((data: any) => {
            if (data.value === solicitacaoI?.tipoAbonoID) {
                setSelected([data]);
            }
        });
        setDadosWorkflow(dadosWorkflowI);
        setSolicitacao(solicitacaoI);
    };

    const CheckHorario = (e: string) => {
        try {
            const inicio = e.split(" às ")[0];
            const fim = e.split(" às ")[1];
            const hora1 = inicio.split(":")[0];
            const minuto1 = inicio.split(":")[1];
            const hora2 = fim.split(":")[0];
            const minuto2 = fim.split(":")[1];

            if (Number(hora1) > 23 || Number(minuto1) > 59) {
                return false;
            }
            if (!Number(hora1 + 1)) return false;

            if (!Number(minuto1 + 1)) return false;

            if (Number(hora2) > 23 || Number(minuto2) > 59) {
                return false;
            }
            if (!Number(hora2 + 1)) return false;

            if (!Number(minuto2 + 1)) return false;

            const date2 = new Date(`2000-01-01 ${hora2}:${minuto2}:00`);
            const date1 = new Date(`2000-01-01 ${hora1}:${minuto1}:00`);

            // eslint-disable-next-line sonarjs/prefer-single-boolean-return
            if (date1.getTime() > date2.getTime()) return false;

            return true;
        } catch (error: any) {
            return false;
        }
    };

    useEffect(() => {
        getAbonos();
    }, [open]);

    useEffect(() => {
        setIsEdit(!inEdit);
    }, [inEdit, open]);

    function validacoesFields() {
        if (periodoAbono === "D") {
            return (
                Number(qtdDias) > 0 &&
                telefone?.toString()?.replace(/\D/g, "").length === 11 &&
                datePicker !== null &&
                selected.length > 0
            );
        }
        if (periodoAbono !== "D") {
            return (
                rangeTime !== "" &&
                telefone?.toString()?.replace(/\D/g, "").length === 11 &&
                datePicker !== null &&
                selected.length > 0
            );
        }
        return false;
    }

    const hasToRenderDeferButtons = (
        <div style={stylesBoxsModalDetalhes.box5}>
            <BtnOutlinePrimary
                style={{ width: 126, marginTop: 24 }}
                onClick={() => {
                    onIndeferir();
                }}
            >
                Indeferir
            </BtnOutlinePrimary>
            <div style={{ width: 20 }} />
            <BtnPrimary
                style={{ width: 126, marginTop: 24 }}
                onClick={() => {
                    setIsEdit(false);
                }}
            >
                Deferir
            </BtnPrimary>
        </div>
    );

    const getCloseButtonLabel = () => {
        if (readOnly) {
            return "Fechar";
        }

        return "Cancelar";
    };

    return (
        <Dialog
            openModal={open}
            onHide={onClose}
            size="width-700 modal-white modal-radius-8"
        >
            <StyledModalTitle className="mb-3">
                Solicitação de abono legal
            </StyledModalTitle>
            <div style={stylesBoxsModalDetalhes.box1}>
                <div style={stylesBoxsModalDetalhes.box2}>
                    <StyledInfoText>
                        Enviado em:{" "}
                        {StringUtils.formatDateString(dadosWorkflow?.data)}
                    </StyledInfoText>
                </div>
            </div>
            <div style={stylesBoxsModalDetalhes.box3}>
                <div style={stylesBoxsModalDetalhes.box4}>
                    <div>
                        <b>
                            <UserIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {dadosWorkflow?.nomeDocente}
                        </b>
                    </div>
                    <div>
                        <b>
                            <InformationIcon
                                style={{ fill: "#8A0538", marginRight: 5 }}
                            />
                            {`Matricula: ${dadosWorkflow?.matriculaDocente}`}
                        </b>
                    </div>
                </div>
            </div>
            <div style={{ height: 20 }} />
            <div style={{ marginTop: 10 }}>
                <AutocompleteAbono
                    onChange={setSelected}
                    options={abonos}
                    placeholder="Tipo de Abono Legal"
                    selected={selected}
                    extraOptions={false}
                    disabled={isEdit}
                />
            </div>
            <div style={{ marginTop: 20 }}>
                <InputCalendarStyles.StyledCalendar
                    placeholder="Data de início do abono"
                    dateFormat="dd/mm/yy"
                    locale="pt-BR"
                    showButtonBar
                    readOnlyInput
                    value={datePicker}
                    onChange={(e: any) => {
                        setDatePicker(e.target?.value);
                    }}
                    disabled={isEdit}
                />
            </div>
            <div style={{ display: "flex", marginTop: 20, marginBottom: 20 }}>
                <CheckRadioStyles.StyledFormCheck
                    inline
                    label="Abono diário"
                    name="group2"
                    type="radio"
                    id="inline-1"
                    checked={periodoAbono === "D"}
                    onChange={() => {
                        setPeriodoAbono("D");
                    }}
                    disabled={isEdit}
                />
                <CheckRadioStyles.StyledFormCheck
                    inline
                    label="Abono por período"
                    name="group2"
                    type="radio"
                    id="inline-1"
                    checked={periodoAbono !== "D"}
                    onChange={() => {
                        setPeriodoAbono("P");
                    }}
                    disabled={isEdit}
                />
            </div>
            {periodoAbono === "D" ? (
                <div style={{ marginTop: 20 }}>
                    <Col>
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="Quantidade1"
                                placeholder="00:00"
                                min="0"
                                max="99"
                                value={qtdDias}
                                onChange={(e) => setQtdDias(e.target.value)}
                                required
                                disabled={isEdit}
                            />
                            <label htmlFor="Quantidade1">
                                Quantidade de dias para abono
                            </label>
                        </div>
                    </Col>
                </div>
            ) : (
                <div style={{ marginTop: 20 }}>
                    <Col>
                        <div>
                            <div className="form-floating">
                                <InputMask
                                    mask="99:99 às 99:99"
                                    className="form-control"
                                    id="MinutosIniciais"
                                    placeholder="00:00 às 00:00"
                                    style={{
                                        marginTop: 9,
                                        width: "100%",
                                        color: CheckHorario(rangeTime)
                                            ? "black"
                                            : "red",
                                        borderColor: CheckHorario(rangeTime)
                                            ? "#787878"
                                            : "red",
                                    }}
                                    onBlur={(_e) =>
                                        CheckHorario(rangeTime)
                                            ? null
                                            : setRangeTime(``)
                                    }
                                    onChange={(e) =>
                                        setRangeTime(`${e.target.value}`)
                                    }
                                    value={rangeTime}
                                    required
                                    disabled={isEdit}
                                />
                                <label htmlFor="Quantidade1">Período</label>
                            </div>
                        </div>
                    </Col>
                </div>
            )}
            <div style={{ marginTop: 20 }}>
                <Col>
                    <div className="form-floating">
                        <input
                            className="form-control"
                            id="email"
                            value={solicitacao?.email}
                            disabled
                        />
                        <label htmlFor="email">E-mail </label>
                    </div>
                </Col>
            </div>
            <div style={{ marginTop: 20 }}>
                <Col>
                    <div className="form-floating">
                        <InputMask
                            mask="(99) 99999-9999"
                            className="form-control"
                            id="MinutosIniciais"
                            placeholder="00:00"
                            value={telefone}
                            onChange={(e) => setTelefone(`${e.target.value}`)}
                            disabled={isEdit}
                            required
                        />
                        <label htmlFor="email">Telefone</label>
                    </div>
                </Col>
            </div>
            {}
            <Row style={{ justifyContent: "center" }}>
                {!isEdit ? (
                    <div style={stylesBoxsModalDetalhes.box5}>
                        <BtnPrimary
                            disabled={!validacoesFields()}
                            style={{ width: "100%", marginTop: 24 }}
                            onClick={() => {
                                const periodoInicioAux =
                                    rangeTime.split(" às ")[0];
                                const periodoFimAux =
                                    rangeTime.split(" às ")[1];
                                onDeferir({
                                    workflowExecucaoId:
                                        dadosWorkflow?.workflowExecucaoId,
                                    docenteId: docenteID,
                                    tipoAbonoID: selected[0]?.value,
                                    data: datePicker
                                        .toISOString()
                                        .split("T")[0],
                                    tipo: periodoAbono,
                                    quantidadeDias: qtdDias,
                                    periodoInicio:
                                        periodoInicioAux !== "undefined"
                                            ? periodoInicioAux
                                            : undefined,
                                    periodoFim:
                                        periodoFimAux !== "undefined"
                                            ? periodoFimAux
                                            : undefined,
                                    email,
                                    telefone,
                                });
                            }}
                        >
                            Confirmar
                        </BtnPrimary>
                    </div>
                ) : (
                    !readOnly && hasToRenderDeferButtons
                )}
                <div style={{ height: 15 }} />
                <Row style={{ justifyContent: "center" }}>
                    <DefaultButtonLink
                        onClick={() => {
                            onClose?.();
                        }}
                    >
                        {getCloseButtonLabel()}
                    </DefaultButtonLink>
                </Row>
            </Row>
        </Dialog>
    );
};

export default ModalDetalhes;
